// App
export const APP_REQUEST_CONFIG = "APP_REQUEST_CONFIG";
export const APP_REQUEST_CONFIG_END = "APP_REQUEST_CONFIG_END";
export const APP_REQUEST_I18N = "APP_REQUEST_I18N";
export const APP_REQUEST_I18N_END = "APP_REQUEST_I18N_END";
export const APP_REQUEST_USERLIST_END = "APP_REQUEST_USERLIST_END";
export const APP_FLUSH_DATAS = "APP_FLUSH_DATAS";
export const APP_ON_LOGIN_PAGE = "APP_ON_LOGIN_PAGE";

// Login
export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const REQUEST_LOGOUT = "REQUEST_LOGOUT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

// User
export const USER_SET_INFORMATIONS = "USER_SET_INFORMATIONS";
export const GET_CONFIGURATION_JSON_START = "GET_CONFIGURATION_JSON_START";
export const GET_CONFIGURATION_JSON_END = "GET_CONFIGURATION_JSON_END";
export const GET_CONFIGURATION_JSON_END_ERROR =
    "GET_CONFIGURATION_JSON_END_ERROR";

// Error
export const ERROR_LOGIN = "ERROR_LOGIN";
export const ERROR_HIDE = "ERROR_HIDE";
export const ERROR_SHOW = "ERROR_SHOW";

// Tasks
export const REQUEST_TASKS = "REQUEST_TASKS";
export const REQUEST_TASKS_SUCCESS = "REQUEST_TASKS_SUCCESS";
export const REQUEST_TASKS_FAIL = "REQUEST_TASKS_FAIL";
export const REQUEST_TASK_SUCCESS = "REQUEST_TASK_SUCCESS";

// Document
export const REQUEST_DOCUMENT = "REQUEST_DOCUMENT";
export const REQUEST_DOCUMENT_SUCCESS = "REQUEST_DOCUMENT_SUCCESS";
export const REQUEST_DOCUMENT_FAIL = "REQUEST_DOCUMENT_FAIL";
export const SET_BATCH_TYPE = "SET_BATCH_TYPE";

// Order
export const REQUEST_ORDERS = "REQUEST_ORDERS";
export const REQUEST_ORDERS_SUCCESS = "REQUEST_ORDERS_SUCCESS";
export const SELECT_ORDER_BATCH = "SELECT_ORDER_BATCH";
export const SELECT_ORDER = "SELECT_ORDER";
export const UNSELECT_ORDER = "UNSELECT_ORDER";
export const CLEAR_SELECTED_ORDERS = "CLEAR_SELECTED_ORDERS";
export const SELECT_ALL_ORDER = "SELECT_ALL_ORDER";
export const SELECT_MULTIPLE_ORDER = "SELECT_MULTIPLE_ORDER";
export const UPDATE_ORDERS_STATUS = "UPDATE_ORDERS_STATUS";
export const REQUEST_ACCEPT_CANCEL_ORDERS = "REQUEST_ACCEPT_CANCEL_ORDERS";
export const REQUEST_ACCEPT_CANCEL_ORDERS_SUCCESS =
    "REQUEST_ACCEPT_CANCEL_ORDERS_SUCCESS";
export const REQUEST_CREATE_ORDERS = "REQUEST_CREATE_ORDERS";
export const REQUEST_CREATE_ORDERS_SUCCESS = "REQUEST_CREATE_ORDERS_SUCCESS";

// FILTERS
export const INIT_FILTERS = "INIT_FILTERS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";

// Upload
export const UPLOAD_START_REQUEST = "UPLOAD_START_REQUEST";
export const UPLOAD_END_REQUEST = "UPLOAD_END_REQUEST";
export const UPLOAD_UPDATE_PROGRESS = "UPLOAD_UPDATE_PROGRESS";

export const ADD_MAIN_UPLOAD_FILE = "ADD_MAIN_UPLOAD_FILE";
export const REMOVE_MAIN_UPLOAD_FILE = "REMOVE_MAIN_UPLOAD_FILE";
export const ADD_ATTACHMENT_UPLOAD_FILE = "ADD_ATTACHMENT_UPLOAD_FILE";
export const REMOVE_ATTACHMENT_UPLOAD_FILE = "REMOVE_ATTACHMENT_UPLOAD_FILE";
export const SET_ATTACHMENT_MANDATORY_FILLED =
    "SET_ATTACHMENT_MANDATORY_FILLED";
export const ADD_INSERT_UPLOAD_FILE = "ADD_INSERT_UPLOAD_FILE";
export const REMOVE_INSERT_UPLOAD_FILE = "REMOVE_INSERT_UPLOAD_FILE";
export const SET_INSERT_MANDATORY_FILLED = "SET_INSERT_MANDATORY_FILLED";

// PDF
export const SHOW_PDF_FILE = "SHOW_PDF_FILE";
export const HIDE_PDF_FILE = "HIDE_PDF_FILE";
export const SET_CANVAS_READY_PDF_FILE = "SET_CANVAS_READY_PDF_FILE";

// TABLE
export const UPDATE_TABLE_LIST = "UPDATE_TABLE_LIST";

// COMMAND
export const COMMAND_CHANGE_VIEW = "COMMAND_CHANGE_VIEW";

// LETTER
export const REQUEST_LETTERS = "REQUEST_LETTERS";
export const REQUEST_LETTERS_SUCCESS = "REQUEST_LETTERS_SUCCESS";
export const SELECT_LETTER = "SELECT_LETTER";
export const UNSELECT_LETTER = "UNSELECT_LETTER";
export const CLEAR_SELECTED_LETTERS = "CLEAR_SELECTED_LETTERS";
export const SELECT_MULTIPLE_LETTER = "SELECT_MULTIPLE_LETTER";
export const UPDATE_LETTER_STATUS = "UPDATE_LETTER_STATUS";

/*
	POMUI
*/

// PREPROCESS
export const REQUEST_PREPROCESS = "REQUEST_PREPROCESS";
export const REQUEST_PREPROCESS_SUCCESS = "REQUEST_PREPROCESS_SUCCESS";
export const SET_PREPROCESS_UPSERTING = "SET_PREPROCESS_UPSERTING";
export const OPEN_MODAL_PREPROCESS = "OPEN_MODAL_PREPROCESS";
export const CLOSE_MODAL_PREPROCESS = "CLOSE_MODAL_PREPROCESS";
export const SET_CONFIG_PARAMETERS_PREPROCESS =
    "SET_CONFIG_PARAMETERS_PREPROCESS";
export const SETTINGS_CHANGE_VIEW = "SETTINGS_CHANGE_VIEW";
export const SET_GETDOCIDLIST = "SET_GETDOCIDLIST";
export const CLEAN_GETDOCIDLIST = "CLEAN_GETDOCIDLIST";

// CRITERION
export const ADD_CRITERION = "ADD_CRITERION";
export const CLEAN_CRITERIONS = "CLEAN_CRITERIONS";
export const REMOVE_CRITERION = "REMOVE_CRITERION";
export const SELECT_CRITERION = "SELECT_CRITERION";
export const UPDATE_CRITERION_SELECTED = "UPDATE_CRITERION_SELECTED";

// SETTINGS
export const SETTINGS_LOAD_CONFIGNAME = "SETTINGS_LOAD_CONFIGNAME";
export const SETTINGS_LOAD_CONFIGNAME_SUCCESS =
    "SETTINGS_LOAD_CONFIGNAME_SUCCESS";

// FILIERE
export const SET_FILIERELIST = "SET_FILIERELIST";
export const CLEAN_FILIERELIST = "CLEAN_FILIERELIST";
export const SELECT_FILIERE = "SELECT_FILIERE";
export const UPDATE_FILIERE_SELECTED = "UPDATE_FILIERE_SELECTED";
export const ADD_FILIERE = "ADD_FILIERE";
export const REMOVE_FILIERE = "REMOVE_FILIERE";

// COMPOSE
export const ADD_COMPOSE = "ADD_COMPOSE";
export const CLEAN_COMPOSES = "CLEAN_COMPOSES";
export const REMOVE_COMPOSE = "REMOVE_COMPOSE";
export const SELECT_COMPOSE = "SELECT_COMPOSE";
export const UPDATE_COMPOSE_SELECTED = "UPDATE_COMPOSE_SELECTED";

// CHANNEL SETTINGS
export const ADD_CHANNEL_SETTINGS = "ADD_CHANNEL_SETTINGS";
export const CLEAN_CHANNEL_SETTINGS = "CLEAN_CHANNEL_SETTINGS";

// OPERATION
export const SELECT_OPERATION = "SELECT_OPERATION";
export const UPDATE_OPERATION_SELECTED = "UPDATE_OPERATION_SELECTED";
export const ADD_OPERATION = "ADD_OPERATION";
export const CLEAN_OPERATIONS = "CLEAN_OPERATIONS";
export const REMOVE_OPERATION = "REMOVE_OPERATION";

// SORT BATCH
export const ADD_SORT_BATCH = "ADD_SORT_BATCH";
export const UPDATE_SORT_BATCH_SELECTED = "UPDATE_SORT_BATCH_SELECTED";
export const CLEAN_SORT_BATCHS = "CLEAN_SORT_BATCHS";
export const SELECT_SORT_BATCH = "SELECT_SORT_BATCH";
export const REMOVE_SORT_BATCH = "REMOVE_SORT_BATCH";

// SPLIT
export const CLEAN_SPLITS = "CLEAN_SPLITS";
export const SELECT_SPLIT = "SELECT_SPLIT";
export const UPDATE_SPLIT_SELECTED = "UPDATE_SPLIT_SELECTED";
export const ADD_SPLIT = "ADD_SPLIT";
export const REMOVE_SPLIT = "REMOVE_SPLIT";

// INSERT
export const CLEAN_INSERTS = "CLEAN_INSERTS";
export const SELECT_INSERT = "SELECT_INSERT";
export const UPDATE_INSERT_SELECTED = "UPDATE_INSERT_SELECTED";
export const ADD_INSERT = "ADD_INSERT";
export const REMOVE_INSERT = "REMOVE_INSERT";

// CSV
export const CLEAN_CSVS = "CLEAN_CSVS";
export const SELECT_CSV = "SELECT_CSV";
export const UPDATE_CSV_SELECTED = "UPDATE_CSV_SELECTED";
export const ADD_CSV = "ADD_CSV";
export const REMOVE_CSV = "REMOVE_CSV";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js